import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-about-final-cta-section',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './about-final-cta-section.component.html',
  styleUrl: './about-final-cta-section.component.scss'
})
export class AboutFinalCtaSectionComponent {}
